import React, { useEffect, useState } from 'react';
import DataTable from '../../../components_shared/DataTable';
import api from '../../../utils/api';
import { Link } from 'react-router-dom';

export default function QcQueuePage(){
  const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [error,setError]=useState(null);
  const load=async()=>{
    try{
      const res=await api.get('/api/v1/inventory/dispatch-notes?status=IN_QC');
      setRows(res.data.content||[]);
    }catch(e){ setError(e.response?.data?.message||e.message);} finally{ setLoading(false);}  };
  useEffect(()=>{ load(); },[]);
  const cols=[
    {accessorKey:'referenceNo',header:'Ref #'},
    {accessorKey:'workOrderNo',header:'Work Order'},
    {accessorKey:'quantity',header:'Qty'},
    {accessorKey:'truckNumber',header:'Truck #'},
    {accessorKey:'status',header:'Status'},
    {id:'act',header:'QC',cell:({row})=>(<Link className="btn btn-sm btn-primary" to={`/qc/blind-evaluation/${row.original.id}`}>Open QC</Link>)},
  ];
  if(loading) return <p>Loading...</p>; if(error) return <div className='alert alert-danger'>{error}</div>;
  return <div className="inventory-page"><div className="premium-card inventory-page-card"><h2>QC Queue</h2><DataTable data={rows} columns={cols}/></div></div>;
}
